/**
 * The week strip on every Home (Lj, Nov 2: "a calendar strip for the week u can click on the day and add tasks … and it puts
 * them in our actual schedule", "it should be globalized", "weather forcasting"). Seven days across every job: how full each
 * day is against a work day, the tasks dated on it by job, calendar events, jobs due, and the forecast (opsWeather/now,
 * published by the books from Environment Canada). Pure.
 */
import { weekKey, weekDays } from './weekplan.js';
import { expandRepeats } from './calendar.js';
import { skyOf } from './weather.js';

const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);
const live = (t) => t && !t.deletedAt && !t.bucket && !t.parentId && t.status !== 'void' && t.status !== 'skipped';

export { skyOf };   // moved to weather.js; kept here for older imports

export const WORK_DAY_MIN = 480;
const fillOf = (min, n, dayMin) => (min >= dayMin * 0.9 ? 'full' : min >= dayMin * 0.4 ? 'part' : min > 0 || n > 0 ? 'light' : null);

/**
 * → { key, from, to, site, days: [{ date, today, past, plannedMin, fill, open, done, late, jobs: [{ projectId, name, color,
 *     tasks }], events, due: [{ id, name, color }], weather: { hi, lo, icon, wet, summary, pop } | null }] }
 */
export function weekStrip({ date, today, tasks = [], events = [], projects = [], weather = null, dayMin = WORK_DAY_MIN } = {}) {
  const key = weekKey(date || today);
  const dates = weekDays(key);
  const from = dates[0]; const to = dates[6];
  const byId = new Map(projects.map((p) => [p.id, p]));
  const evs = expandRepeats(events, from, to).filter((e) => e && e.status !== 'cancelled' && !e.deletedAt);
  const sky = new Map((weather?.days || []).map((w) => [w.date, w]));
  const days = dates.map((d) => {
    const mine = tasks.filter((t) => live(t) && t.scheduledDate === d);
    const late = d === today ? tasks.filter((t) => live(t) && t.status === 'todo' && t.scheduledDate && t.scheduledDate < today) : [];
    const groups = new Map();
    for (const t of [...mine].sort((a, b) => (a.status === 'done') - (b.status === 'done') || num(a.sortOrder) - num(b.sortOrder))) {
      const k = t.projectId || '';
      if (!groups.has(k)) { const p = byId.get(t.projectId); groups.set(k, { projectId: t.projectId || null, name: p?.name || 'No job', color: p?.color || null, tasks: [] }); }
      groups.get(k).tasks.push({ id: t.id, title: t.title || 'Task', done: t.status === 'done', estMin: num(t.estimatedMinutes) || null, time: t.scheduledTime || null });
    }
    const plannedMin = mine.reduce((a, t) => a + num(t.estimatedMinutes), 0);
    const w = sky.get(d);
    return {
      date: d, today: d === today, past: d < today, plannedMin, fill: fillOf(plannedMin, mine.length, dayMin),
      open: mine.filter((t) => t.status !== 'done').length, done: mine.filter((t) => t.status === 'done').length, late: late.length,
      jobs: [...groups.values()].sort((a, b) => (a.projectId ? 0 : 1) - (b.projectId ? 0 : 1)),
      events: evs.filter((e) => e.date === d).sort((a, b) => (a.allDay ? -1 : num(a.start)) - (b.allDay ? -1 : num(b.start))).map((e) => ({ id: e.id, title: e.title || 'Event', allDay: !!e.allDay, start: e.start || e.startTime || null })),
      due: projects.filter((p) => p && p.endDate === d && (p.status || 'active') === 'active' && !p.deletedAt).map((p) => ({ id: p.id, name: p.name || 'Job', color: p.color || null })),
      weather: w ? { hi: w.hi ?? null, lo: w.lo ?? null, ...skyOf(w.code), summary: w.summary || null, pop: w.pop ?? null } : null,
    };
  });
  return { key, from, to, site: weather?.site?.name || null, issuedAt: weather?.issuedAt || null, days };
}
